<script setup>
import { ref, onUpdated, onMounted, defineProps, defineEmits } from "vue"
import useLiturgies from "../../use/useLiturgies"

import Editor from "ckeditor5-custom-build/build/ckeditor"
import CKEditor from "@ckeditor/ckeditor5-vue"

import store from "../../state/store"

const props = defineProps({
  modelValue: Boolean,
  liturgy: {
    required: true,
    type: Object,
  },
  allLiturgyCategories: {
    required: true,
    type: Object,
  },
})

const liturgyData = ref({
  id: props.liturgy.id,
  liturgy_category_id: props.liturgy.liturgy_category_id,
  text: props.liturgy.text,
  date: props.liturgy.date,
})

const emit = defineEmits(["update:modelValue", "close"])

const { show, loading, errors, onSubmit, closeModal } = useLiturgies(
  props,
  emit,
  liturgyData
)

onUpdated(() => {
  liturgyData.value = {
    id: props.liturgy.id,
    liturgy_category_id: props.liturgy.liturgy_category_id,
    text: props.liturgy.text,
    date: props.liturgy.date,
  }
})

onMounted(() => {
  store.dispatch("getAllLiturgyCategories")
})

/**
 *! start editor
 */

const editorConfig = {
  language: "fa",
  ckfinder: {
    options: {
      language: "fa",
    },
  },
}

const editor = Editor
const ckeditor = CKEditor.component

/**
 *! end editor
 */
</script>

<template>
  <!-- add and edit liturgy modal  -->
  <b-modal
    v-model="show"
    @close="closeModal()"
    id="showModal"
    hide-footer
    title=" ویرایش ویژگی"
    header-class="p-3 bg-light"
    class="v-modal-custom"
    centered
    no-close-on-backdrop
    size="lg"
  >
    <b-overlay
      variant="white"
      opacity="0.75"
      blur="2px"
      :show="loading"
      spinner-variant="success"
      rounded="sm"
    >
      <b-card>
        <b-form
          id="addform"
          class="tablelist-form"
          autocomplete="off"
          @submit.prevent="onSubmit"
          enctype="multipart/form-data"
        >
          <div class="mb-3">
            <label for="name" class="form-label">دسته بندی </label>
            <select
              class="form-select mb-3"
              v-model="liturgyData.liturgy_category_id"
            >
              <option value="">انتخاب دسته بندی</option>
              <option
                v-for="category in allLiturgyCategories.data"
                :value="category.id"
                :key="category.id"
              >
                {{ category.title }}
              </option>
            </select>
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.liturgy_category_id">
                <span>{{ errors.liturgy_category_id[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="liturgydate" class="form-label">تاریخ نیایش روز</label>
            <input
              type="date"
              id="liturgydate"
              class="form-control"
              placeholder="تاریخ نیایش روز"
              v-model="liturgyData.date"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.date">
                <span>{{ errors.date[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="liturgytext" class="form-label">متن نیایش روز</label>
            <ckeditor
              :editor="editor"
              :config="editorConfig"
              v-model="liturgyData.text"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.text">
                <span>{{ errors.text[0] }}</span>
              </div>
            </div>
          </div>

          <div class="hstack gap-2 justify-content-end">
            <b-button
              type="button"
              id="closemodal"
              variant="light"
              @click="closeModal"
            >
              بستن
            </b-button>
            <b-button type="submit" variant="success"
              >ویرایش نیایش روز</b-button
            >
          </div>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
